import { Component } from '@angular/core';


export class SkyModalFooterComponent {
static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'sky-modal-footer',
  template: `<div class="sky-modal-footer-container">
  <ng-content></ng-content>
</div>
`,
  styles: [`.sky-modal-footer-container {
  background-color: #fff;
  padding: 15px;
  border-top: 1px solid #e2e3e4;
  /* Offset the margin-left of the link */
}

.sky-modal-footer-container /deep/ .sky-btn-link:first-child {
  margin-left: -12px;
}
`]
}, ] },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
